import { service_request_status } from '@trashlab/api/src/domains/website/schemas/service-request';

export type ServiceRequestStatusTypes =
  (typeof service_request_status.enumValues)[number];

export enum ServiceRequestStatus {
  PENDING = 'PENDING',
  CONTACTED = 'CONTACTED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export const serviceRequestStatusValues =
  service_request_status.enumValues as ServiceRequestStatusTypes[];
